import React, { useState } from 'react';
import { X, Mail, Download, AlertCircle, Loader2 } from 'lucide-react';

const EmailReportModal = ({ darkMode, onClose, onSendReport, systemName }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [downloadMode, setDownloadMode] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (downloadMode) {
      try {
        setLoading(true);
        await onSendReport('download'); // result değişkeni kullanılmıyor
        setSuccess('Rapor indirme işlemi başarılı.');
        setTimeout(() => onClose(), 2000);
      } catch (error) {
        setError('Rapor indirilemedi. Lütfen tekrar deneyiniz.');
      } finally {
        setLoading(false);
      }
      return;
    }
    
    // E-posta doğrulama
    if (!email || !email.includes('@') || !email.includes('.')) {
      setError('Lütfen geçerli bir e-posta adresi giriniz.');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      await onSendReport(email); // result değişkeni kullanılmıyor
      setSuccess('Rapor başarıyla gönderildi!');
      setTimeout(() => onClose(), 2000);
    } catch (error) {
      setError('Rapor gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className={`${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} rounded-lg shadow-xl p-6 w-96 relative`}>
        <button 
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <X size={20} />
        </button>
        
        <h2 className="text-xl font-bold mb-4">Rapor Gönder</h2>
        <p className="text-sm mb-4">
          {systemName} sistem raporu e-posta adresinize PDF olarak gönderilecektir.
        </p>
        
        <div className="flex gap-2 mb-4">
          <button 
            type="button"
            onClick={() => setDownloadMode(false)}
            className={`flex-1 py-2 rounded-lg flex items-center justify-center gap-2 ${
              !downloadMode 
                ? `${darkMode ? 'bg-blue-600 text-white' : 'bg-blue-500 text-white'}` 
                : `${darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-600'}`
            }`}
          >
            <Mail size={18} />
            <span>E-posta</span>
          </button>
          
          <button 
            type="button"
            onClick={() => setDownloadMode(true)}
            className={`flex-1 py-2 rounded-lg flex items-center justify-center gap-2 ${
              downloadMode 
                ? `${darkMode ? 'bg-blue-600 text-white' : 'bg-blue-500 text-white'}` 
                : `${darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-600'}`
            }`}
          >
            <Download size={18} />
            <span>İndir</span>
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          {!downloadMode && (
            <div className="mb-4">
              <label htmlFor="email" className={`block mb-1 text-sm font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                E-posta Adresi
              </label>
              <input
                type="email"
                id="email"
                className={`w-full p-2.5 rounded-lg border ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="ornek@firma.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required={!downloadMode}
              />
            </div>
          )}
          
          {downloadMode && (
            <div className="mb-4 p-3 bg-blue-100 text-blue-800 rounded-lg flex items-center gap-2">
              <AlertCircle size={18} />
              <span className="text-sm">
                Rapor doğrudan cihazınıza indirilecektir.
              </span>
            </div>
          )}
          
          {error && (
            <div className="mb-4 p-2 bg-red-100 text-red-700 rounded-lg text-sm">
              {error}
            </div>
          )}
          
          {success && (
            <div className="mb-4 p-2 bg-green-100 text-green-700 rounded-lg text-sm">
              {success}
            </div>
          )}
          
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className={`px-4 py-2 rounded-lg ${darkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'}`}
              disabled={loading}
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 flex items-center justify-center min-w-[100px] gap-2 ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              {loading ? (
                <>
                  <Loader2 size={18} className="animate-spin" />
                  <span>İşleniyor...</span>
                </>
              ) : (
                <>
                  {downloadMode ? <Download size={18} /> : <Mail size={18} />}
                  <span>{downloadMode ? 'İndir' : 'Gönder'}</span>
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailReportModal;